import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "columns is-mobile is-centered" }
const _hoisted_3 = { class: "column is-half" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "is-size-7" }

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  setup(__props) {

const store = useStore();

const error = computed(() => store.getters.error);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "title" }, "An unexpected error has occurred", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "subtitle" }, "Please try again by navigating to another page or refreshing.", -1)),
            _createElementVNode("p", _hoisted_6, "Details: " + _toDisplayString(error.value), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})